import React from 'react';
import { observer } from 'mobx-react';

import Toolbar from '@mui/material/Toolbar';

import stores from '@stores';
import * as S from './styles';

interface Props {
  children?: React.ReactNode
}

const expandDrawerWidth = 250;
const collapseDrawerWidth = 70;

const MainContent = ({ children }: Props) => {
  const {
    layoutStore: { isDrawerOpen }
  } = stores;
  return (
    <S.Wrapper
      leftspace={isDrawerOpen ? expandDrawerWidth : collapseDrawerWidth}
      component="main"
    >
      <Toolbar/>
      {children}
    </S.Wrapper>
  );
};

export default observer(MainContent);

